import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { changeChannel } from "store/accountActions";
import { logoutAndPurge } from "managers/baseManager";

import classnames from "classnames";
import {
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Button,
  Input,
} from "reactstrap";

import issuerNavs from "menu-items";
import { handleLogoutCall } from "./callApi";

import NotificationAlert from "react-notification-alert";

import { staticData } from "managers/staticDataManager";
import { withLang } from "managers/routeManager";
import LanguageSelect from "components/LanguageSelect/LanguageSelect";
import "../../assets/css/navbar.css";

const IssuerNavbar = () => {
  const dispatch = useDispatch();

  const state = useSelector((state) => state);

  const [isBusy, setIsBusy] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const notificationAlertRef = React.useRef(null);

  const handleLogout = (e) => {
    e.preventDefault();
    handleLogoutCall(state, setIsBusy, logoutUser, notificationAlertRef);
  };

  const logoutUser = () => {
    logoutAndPurge();
  };

  const handleChannelChange = (e) => {
    const channelId = parseInt(e.target.value);
    dispatch(changeChannel({ channelId }));
  };

  const displayChannelList = (fullWidth = false) => {
    return (
      <Input
        id="ddlChannelsList"
        type="select"
        value={state.account?.channel?.channelId || ""}
        onChange={handleChannelChange}
        style={{ width: fullWidth ? "100%" : "95px" }}
      >
        {state.account?.channels?.map((channel) => (
          <option key={channel?.channelId} value={channel?.channelId}>
            {channel?.code}
          </option>
        ))}
      </Input>
    );
  };

  const displayLogoutButton = (fullWidth = false) => {
    return (
      <Button
        className={classnames("btn-round mb-0", {
          "w-100": fullWidth,
        })}
        color="danger"
        onClick={handleLogout}
        type="button"
        disabled={isBusy}
      >
        {isBusy
          ? "..."
          : staticData.loadTerms(state, "VW_ISSUER_IssuerNavbar_Logout")}
      </Button>
    );
  };

  return (
    <>
      <Navbar
        className={classnames("fixed-top")}
        color-on-scroll="300"
        expand="lg"
      >
        <Container fluid className="d-flex align-items-center">
          <div className="navbar-translate d-none d-lg-flex align-items-center">
            {displayChannelList()}
          </div>

          <Nav
            navbar
            className="d-none d-lg-flex align-items-center justify-content-center flex-grow-1"
          >
            {issuerNavs.map((item) => (
              <NavItem key={`item-${item.id}`} className="mx-2">
                <NavLink
                  key={item.id}
                  to={withLang(state, item.url)}
                  tag={Link}
                  className="d-flex align-items-center"
                >
                  <i className={`nc-icon ${item.icon}`} />
                  <span className="ml-1">
                    {staticData.loadTerms(state, item.title)}
                  </span>
                </NavLink>
              </NavItem>
            ))}
          </Nav>

          <Nav navbar className="d-none d-lg-flex align-items-center ml-auto">
            <NavItem className="mr-2">
              <LanguageSelect />
            </NavItem>
            <NavItem>{displayLogoutButton()}</NavItem>
          </Nav>

          <div className="d-flex d-lg-none justify-content-end w-100">
            <button
              className="navbar-toggler"
              type="button"
              onClick={() => setMobileSidebarOpen(true)}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>

          <div className="react-notification-alert-container">
            <NotificationAlert ref={notificationAlertRef} />
          </div>
        </Container>
      </Navbar>

      <div
        className={classnames("issuer-mobile-sidebar-overlay", {
          show: mobileSidebarOpen,
        })}
        onClick={() => setMobileSidebarOpen(false)}
      />

      <div
        className={classnames("issuer-mobile-sidebar", {
          show: mobileSidebarOpen,
        })}
      >
        <div className="d-flex align-items-center justify-content-between mb-4">
          <strong>
            {staticData.loadTerms(state, "VW_COMMON_MENU_TITLE") || "Menu"}
          </strong>

          <Button
            className="btn-icon btn-round mt-2"
            color="neutral"
            type="button"
            onClick={() => setMobileSidebarOpen(false)}
          >
            <i className="nc-icon nc-simple-remove" />
          </Button>
        </div>

        <div className="mb-3">
          <label className="mb-1">Channel</label>
          {displayChannelList(true)}
        </div>

        <div className="mb-3">
          <label className="mb-1">
            {staticData.loadTerms(state, "VW_COMMON_LANGUAGE")}
          </label>
          <LanguageSelect
            fullWidth
            onLanguageChanged={() => setMobileSidebarOpen(false)}
          />
        </div>

        <div className="mt-4">{displayLogoutButton(true)}</div>
      </div>
    </>
  );
};

export default IssuerNavbar;
